import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";
// create slice = combination of reducer and action

const name = "schedule";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const scheduleActions = { ...slice.actions, ...extraActions };
export const scheduleReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    data: [],
    scheduleItem: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}/schedule`;

  return {
    getAllSchedule: getAllSchedule(),
    createPostSchedule: createPostSchedule(),
  };

  function getAllSchedule() {
    return createAsyncThunk(
      `${name}/getUsersSchedule/getById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/getUsersSchedule/${id}`)
    );
  }
  function createPostSchedule() {
    return createAsyncThunk(
      `${name}/create`,
      async (data) => await fetchWrapper.post(`${baseUrl}/createMultipleDeliverySchedule`, data)
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    getAllSchedule();
    function getAllSchedule() {
      var { pending, fulfilled, rejected } = extraActions.getAllSchedule;
      builder
        .addCase(pending, (state) => {
          state.scheduleItem = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.scheduleItem = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.scheduleItem = { error: action.error };
        });
    }
  };
}
function createReducers() {
  return {
    addNewSchedule,
  };

  function addNewSchedule(state, action) {
    state.data = action.payload;
  }
}
